/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { withHousehold } from 'Context/HouseholdContext';
import Household from 'Classes/Household';
import DashboardNotes from './Notes';
import QuickLinks from './Links';
import Goals from './Goals';

import './index.css';

function NotesGoalsAndInterests({ household }) {
  return (
    <Paper className="NotesGoalsAndInterests" elevation={1}>
      <DashboardNotes />
      <QuickLinks
        primaryClientFirstName={household.primaryClientFirstName}
        primaryClientLastName={household.primaryClientLastName}
        linkColor="primaryGray"
      />
      <Goals />
    </Paper>
  );
}

NotesGoalsAndInterests.propTypes = {
  household: PropTypes.instanceOf(Household).isRequired,
};

export default withHousehold(NotesGoalsAndInterests);
